import React from "react";
import { useTranslation } from "react-i18next";
import { ModalSheet } from "./ModalSheet";
import { LegalDocumentsList } from "./LegalDocumentsList";

type LegalDocumentsSheetProps = {
  open: boolean;
  onClose: () => void;
};

export function LegalDocumentsSheet({ open, onClose }: LegalDocumentsSheetProps) {
  const { t } = useTranslation();
  return (
    <ModalSheet
      open={open}
      onClose={onClose}
      title={t("profile.menu_documents")}
      height="auto"
    >
      <p className="text-[12px] text-gray-500 mb-3">{t("profile.menu_documents_desc")}</p>
      <LegalDocumentsList compact />
    </ModalSheet>
  );
}
